import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import type { HouseAction } from '@stores/house/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import Toast from '@components/Toast';
import { getUrlParams } from '@utils/getUrlParams';
import { houseCertlike, readHouseCertTotal, houseCertGenerate } from '@server';
import { px2rem } from '@utils/px2rem'
import CommonPopupNew from "@components/commonPopupNew";
import CommonRulePopup from "@components/commonRulePopup";
import { position } from 'html2canvas/dist/types/css/property-descriptors/position';
import { getCookie } from '@utils/cookie';
interface HouseLikeH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    house?: HouseAction;
}
interface HouseLikeH5State {
    loading: boolean;
    error: any
    pageLoaded: any
    likeCountList: any
    likeUserList: any
    bulletConfigs: any
    rulePopupStatus: boolean
    prizePopupStatus: boolean
    prizeScore: number
    floatingLikes: Array<{ id: number, left: number }> // 飘动的点赞图标列表
    likeCountNumber?: number
    likeBtnAnimating?: boolean
    routerSource?: any
    isIssued?: any
    downloadAppStatus: boolean; // 是否显示下载入口，用来记录下载入口的初始化状态，返回到其他页面后恢复下载入口的显示状态
    headerShowStatus: boolean;  // 是否显示header，用来记录header的初始化状态，返回到其他页面后恢复header的显示状态
    hasHouseCert: boolean
}
@inject('app', 'site', 'user', 'house')
@observer
class HouseLikeH5Page extends BasePage<HouseLikeH5PageProps, HouseLikeH5State> {
    private hasLoginState = () => {
        const { user } = this.props;
        return !!getCookie('user_code') || !!user?.isLoggedIn || !!user?.userInfo || !!user?.token;
    };
    // 处理图片加载错误
    handleImageError: React.ReactEventHandler<HTMLImageElement> = (event) => {
        const imgElement = event.currentTarget;
        imgElement.src = `${BASE_IMG_URL}/common/avatar.png`;
        // 防止默认图也加载失败时陷入死循环
        imgElement.onerror = null;
    };
    // 轨道滚动控制（JS 驱动逐条循环）
    private laneRefs: Array<React.RefObject<HTMLDivElement>> = [];
    private laneRafIds: number[] = [];
    private laneOffsets: number[] = [];
    private laneSpeeds: number[] = [60, 66, 58, 70, 62]; // px/s，与构建参数一致
    private baseGap: number = 40; // 与 SCSS .likeUserItem 的 margin-right 保持一致
        // 获取稳定的轨道 ref（在渲染时调用）
        private getLaneRef = (index: number) => {
            if (!this.laneRefs[index]) {
                this.laneRefs[index] = React.createRef<HTMLDivElement>();
            }
            return this.laneRefs[index];
        }
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        likeCountList: [8, 8, 3, 4, 5, 5, 2],  // 点赞数分割成数组
        likeCountNumber: 0,
        likeUserList: [
            // 初始占位，componentDidMount 中会生成更多测试数据
            { avatar: 'https://img0.baidu.com/it/u=277019952,3995429602&fm=253&app=138&f=JPEG?w=800&h=1200', content: '+108', type: 1 },
            { avatar: 'https://img0.baidu.com/it/u=277019952,3995429602&fm=253&app=138&f=JPEG?w=800&h=1200', content: '抽中99V币', type: 2 }
        ],   // 点赞用户列表
        bulletConfigs: [],
        rulePopupStatus: false, // 规则弹框是否显示
        prizePopupStatus: false,    // 中奖弹框
        prizeScore: 0,    // 中奖金额
        floatingLikes: [],  // 飘动的点赞图标
        likeBtnAnimating: false,
        routerSource: '',   // 路由上的source参数
        isIssued: false,    // 是否领取过房产证
        downloadAppStatus: false, // 是否显示下载入口
        headerShowStatus: false,  // 是否显示header
        hasHouseCert: true, // 是否已获取房产证
    }
    componentDidMount() {
        super.componentDidMount();
        const { site } = this.props;
        
        if (site) {
            this.setState({
                downloadAppStatus: site.getAppDownloadShowStatus(),
                headerShowStatus: site.getShowHeader(),

            }, () => {
                site.setShowHeader(false);
                site.setAppDownloadShowStatus(false);
            })
        }
        const routerParams = new URLSearchParams(this.props.location.search);
        const source: any = routerParams?.get('source') || '';

        this.setState({
            routerSource: source
        })
        // 获取房产证活动统计数据
        this.fetchHouseCertTotal();
        this.getHouseCardDetail();
    }

    // 获取房产证卡片信息
    getHouseCardDetail() {
        const routerParams = new URLSearchParams(this.props.location.search);
        const source: any = routerParams?.get('source') || '';
        const { house, user } = this.props;
        if (!this.hasLoginState()) {
            return;
        }
        if(house) {
            house.getHouseCert().then(res => {
                console.log('获取房产证信息', res.data?.is_issued);
                if(res.code == 0) {
                    // if(res.data?.is_issued) {   // 如果已领取，直接显示房产证信息
                    //     // const queryParams = source === 'app' ? '?rotate=1&source=app' : '?rotate=1';
                    //     // this.props.history.push(`/houseCard${queryParams}`);
                    // } else {  // 如果未领取，走领取流程
                        
                    // }
                    this.setState({
                        isIssued: res.data?.is_issued
                    })
                } else if(res.code == -4004) {  // 尚未生成房产证
                    this.setState({
                        hasHouseCert: false
                    })
                }
            })
        }
    }

    componentDidUpdate(prevProps: HouseLikeH5PageProps, prevState: HouseLikeH5State) {
        if (prevState.bulletConfigs !== this.state.bulletConfigs) {
            this.setupLaneTickers();
        }
    }

    componentWillUnmount(): void {
        this.stopLaneTickers();

        let { downloadAppStatus, headerShowStatus} = this.state;
        const { site } = this.props;
        if(site) {
            site.setShowHeader(headerShowStatus);
            site.setAppDownloadShowStatus(downloadAppStatus);
        }
    }

    // 获取房产证活动统计数据
    fetchHouseCertTotal = async () => {
        try {
            const response = await readHouseCertTotal({});
            // 适配两种响应格式：response.data 或 response.Data
            const data = response && (response.data || response.Data);
            if (data) {
                const { user, likeList, likeCount } = data;
                let a = 8796787767567;
                // likeCount 是总的集赞数（用于数字转盘），user.likeCount 是当前用户的点赞数（用于按钮显示）
                const totalLikeCount = Number(likeCount) > 9999999 ? 9999999 : Number(likeCount) || 0;
                const userLikeCount = user?.likeCount ?? 0;

                // 处理 likeCountList - 将总集赞数拆分成数组并补零到固定长度
                const likeCountArray = this.formatLikeCount(totalLikeCount, 7);

                // 处理 likeUserList - 转换数据格式
                const formattedList = likeList.map((item: any) => {
                    const content = item.type === 1
                        ? `+${item.like_count}`
                        : `抽中${item.score}V币`;

                    return {
                        avatar: item.user.avatar,
                        content: content,
                        type: item.type
                    };
                });

                // 生成弹幕配置（基于内容宽度与轨道速度的精确调度）
                const bulletConfigs = this.buildBulletConfigs(formattedList);

                this.setState({
                    likeCountList: likeCountArray,
                    likeUserList: formattedList,
                    bulletConfigs,
                    likeCountNumber: userLikeCount, // 显示当前用户的点赞数
                });
            }
        } catch (error) {
            console.error('获取房产证统计数据失败:', error);
            // 失败时使用本地测试数据
            const likeUsers = this.generateLikeUsers(30);
            const bulletConfigs = this.buildBulletConfigs(likeUsers);
                this.setState({ likeUserList: likeUsers, bulletConfigs, likeCountNumber: 0 });
        }
    }

    // 生成测试的点赞/中奖用户数据（头像相同即可）
    generateLikeUsers = (count: number) => {
        const avatar = 'https://img0.baidu.com/it/u=277019952,3995429602&fm=253&app=138&f=JPEG?w=800&h=1200';
        const likeContents = ['+66', '+88', '+108', '+188', '+300', '+520', '+777'];
        const prizeContents = ['抽中18V币', '抽中66V币', '抽中88V币', '抽中99V币', '抽中188V币'];
        const list: any[] = [];
        for (let i = 0; i < count; i++) {
            const isPrize = Math.random() < 0.35; // 约35%为中奖弹幕，错峰更自然
            const content = isPrize
                ? prizeContents[Math.floor(Math.random() * prizeContents.length)]
                : likeContents[Math.floor(Math.random() * likeContents.length)];
            list.push({ avatar, content, type: isPrize ? 2 : 1 });
        }
        return list;
    }

    formatLikeCount = (num: number, length: number) => {
        const s = String(Math.max(0, Math.floor(num))).padStart(length, '0');
        return s.split('').map(ch => Number(ch));
    }

    
        measureTextWidth = (text: string, fontPx = 20) => {
            try {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                if (!ctx) return text.length * fontPx; // 兜底估算
                ctx.font = `${fontPx}px -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, 'PingFang SC', 'Microsoft YaHei'`;
                const metrics = ctx.measureText(text || '');
                return Math.ceil(metrics.width);
            } catch {
                return text.length * fontPx;
            }
        }

        buildBulletConfigs = (users: Array<{ avatar: string; content: string; type: number }>) => {
            const lanes = 5; // 5条弹幕轨道
            const laneSpeeds = [60, 66, 58, 70, 62]; // px/s
            const baseGap = 40;

            // 布局常量（与 SCSS 对齐）
            const avatarW = 68; // .avatar 宽度
            const iconW = 28;   // .likeIcon 宽度
            const padL = 34;    // .likeUserItem 左内边距
            const padR = 24;    // .likeUserItem 右内边距
            const gap = 8;      // 元素之间的水平间隙
            const fontPx = 20;  // 文本字号（px），需与 SCSS 保持一致

            // 分配用户到各轨道
            const laneUsers: Array<Array<{ avatar: string; content: string; type: number }>> = new Array(lanes).fill(0).map(() => []);
            users.forEach((u, i) => laneUsers[i % lanes].push(u));

            // 为每条轨道计算滚动距离和动画时长
            const metrics = laneUsers.map((lu, laneIndex) => {
                const speed = laneSpeeds[laneIndex];
                let total = 0;
                for (const user of lu) {
                    const textW = this.measureTextWidth(user.content, fontPx);
                    const hasIcon = user.type === 1 || user.type === 2;
                    const itemW = padL + avatarW + gap + (hasIcon ? (iconW + gap) : 0) + textW + padR;
                    total += itemW + baseGap;
                }
                const scrollDistance = Math.max(total, 400); // 最小距离兜底
                const duration = scrollDistance / speed;
                return { scrollDistance, duration, laneUsers: lu };
            });

            return metrics as any;
        }

    // 初始化并启动各轨道的逐条循环滚动
    private setupLaneTickers() {
        const laneCount = (this.state.bulletConfigs || []).length;
        // 重置偏移
        this.laneOffsets = new Array(laneCount).fill(0);
        // 停止旧 ticker
        this.stopLaneTickers();
        // 启动新 ticker（延时以确保 DOM 渲染完成）
        setTimeout(() => {
            for (let i = 0; i < laneCount; i++) this.startLaneTicker(i);
        }, 0);
    }

    private stopLaneTickers() {
        this.laneRafIds.forEach(id => cancelAnimationFrame(id));
        this.laneRafIds = [];
    }

    private startLaneTicker(laneIndex: number) {
        const speed = this.laneSpeeds[laneIndex % this.laneSpeeds.length];
        const container = this.laneRefs[laneIndex]?.current;
        if (!container) return;

        let lastTs = -1;
        const step = (ts: number) => {
            if (lastTs < 0) lastTs = ts;
            const dt = Math.max(0, (ts - lastTs) / 1000);
            lastTs = ts;

            // 更新偏移
            this.laneOffsets[laneIndex] -= speed * dt;
            container.style.transform = `translateX(${this.laneOffsets[laneIndex]}px)`;

            // 当第一个子元素完全离开左侧视窗时，移到末尾并补位
            let first = container.firstElementChild as HTMLElement | null;
            if (first) {
                const firstRect = first.getBoundingClientRect();
                const marginRight = parseFloat(window.getComputedStyle(first).marginRight || '0');
                const firstWidth = firstRect.width + marginRight;
                // 判断是否完全离开（偏移量小于 -firstWidth）
                while (this.laneOffsets[laneIndex] <= -firstWidth && first) {
                    // 将第一个元素移到末尾
                    container.appendChild(first);
                    // 补回偏移量，让视觉保持连续
                    this.laneOffsets[laneIndex] += firstWidth;
                    container.style.transform = `translateX(${this.laneOffsets[laneIndex]}px)`;
                    // 更新 first 与其宽度
                    first = container.firstElementChild as HTMLElement | null;
                    if (!first) break;
                }
            }

            this.laneRafIds[laneIndex] = requestAnimationFrame(step);
        };
        this.laneRafIds[laneIndex] = requestAnimationFrame(step);
    }

    // 关闭弹框
    onHidePopup = () => {
        this.setState({
            rulePopupStatus: false,
            prizePopupStatus: false
        })
    }

    // 点赞按钮点击事件（要求先登录）
    onLikeClick = async () => {
        const { user } = this.props as any;
        // 使用 user.onEnsureLogin 保证已登录，未登录时由该方法处理跳转
        if (user && typeof user.onEnsureLogin === 'function') {
            user.onEnsureLogin(async () => {
                // 触发点击缩放动画
                this.setState({ likeBtnAnimating: true });
                setTimeout(() => this.setState({ likeBtnAnimating: false }), 300);

                try {
                    // 调用点赞接口
                    const response = await houseCertlike({});
                    console.log('点赞成功:', response);

                    // 如果接口返回 likeCount，更新按钮显示和数字列表
                    const responseData = response && (response.Data || response.data);
                    if (responseData) {
                        const userLikeCountVal = responseData.likeCount ?? 0;
                        const scoreVal = responseData.score ?? 0;

                        if (userLikeCountVal !== undefined && userLikeCountVal !== null) {
                            this.setState({ likeCountNumber: Number(userLikeCountVal) || 0 });
                        }

                        // 点赞成功后，重新拉取服务端权威总数，避免本地乐观累加与服务端真实值不一致导致数字回退/错位
                        this.fetchHouseCertTotal();

                        if (scoreVal && scoreVal !== 0) {
                            this.setState({ prizePopupStatus: true, prizeScore: scoreVal });
                        }
                    }
                } catch (error) {
                    console.error('点赞失败:', error);
                    Toast.error({
                        content: '点赞失败，请重试',
                        duration: 2000,
                    });
                }

                // 加入一个飘动的点赞图标
                const id = Date.now() + Math.random();
                const left = -60 + Math.random() * 120;
                const xOffset = -50 + Math.random() * 100;
                const newLike = { id, left, xOffset } as any;

                this.setState((prevState) => ({
                    floatingLikes: [...(prevState?.floatingLikes || []), newLike]
                }));

                setTimeout(() => {
                    this.setState((prevState) => ({
                        floatingLikes: (prevState?.floatingLikes || []).filter(like => like.id !== id)
                    }));
                }, 2500);
            });
        } else {
            // 无 user 或 onEnsureLogin 不存在，直接执行原逻辑作为 fallback
            console.warn('user.onEnsureLogin 未提供，直接执行点赞逻辑');
            // 触发点击缩放动画
            this.setState({ likeBtnAnimating: true });
            setTimeout(() => this.setState({ likeBtnAnimating: false }), 300);
            try {
                const response = await houseCertlike({});
                const responseData = response && (response.Data || response.data);
                if (responseData) {
                    const userLikeCountVal = responseData.likeCount ?? 0;
                    const scoreVal = responseData.score ?? 0;
                    if (userLikeCountVal !== undefined && userLikeCountVal !== null) {
                        this.setState({ likeCountNumber: Number(userLikeCountVal) || 0 });
                    }
                    // 点赞成功后，重新拉取服务端权威总数，避免本地乐观累加与服务端真实值不一致导致数字回退/错位
                    this.fetchHouseCertTotal();
                    if (scoreVal && scoreVal !== 0) {
                        this.setState({ prizePopupStatus: true, prizeScore: scoreVal });
                    }
                }
            } catch (error) {
                console.error('点赞失败:', error);
                Toast.error({ content: '点赞失败，请重试', duration: 2000 });
            }
        }
    }

    // 领取房产证按钮点击时，调用生成房产证接口
    claimHouseCert = async () => {
        const { routerSource, isIssued, hasHouseCert } = this.state;
        const { house, history } = this.props;
        
        try {
            // 构建路径的工具函数
            const buildPath = (isIssued: boolean, routerSource: string): string => {
                const params = [];
                if (isIssued) params.push('rotate=1');
                if (routerSource === 'app') params.push('source=app');
                return params.length ? `/houseCard?${params.join('&')}` : '/houseCard';
            };

            // 在方法中使用
            if (!hasHouseCert) {
                if (!house) {
                    Toast.error({ content: '生成失败，请重试', duration: 2000 });
                    return;
                }
                
                const response = await house.houseCertGenerate();
                console.log('获取房产证信息', response.data?.is_issued);
                
                if (response.code === 0) {
                    history.push(buildPath(isIssued, routerSource));
                } else {
                    Toast.error({ content: '生成失败，请重试', duration: 2000 });
                }
            } else {
                history.push(buildPath(isIssued, routerSource));
            }
        } catch (error) {
            // console.error('claimHouseCert error:', error);
            Toast.error({
                content: '操作失败，请重试',
                duration: 2000,
            });
        }
    };

    render() {
        let { likeCountList, likeUserList, bulletConfigs, rulePopupStatus, prizePopupStatus, routerSource, isIssued, floatingLikes } = this.state;
        console.log(floatingLikes, '点赞小手')
        return (
            <div className={styles.houseWrap}>
                <img src={`${BASE_IMG_URL}/house/bg10.png`} alt="" className={styles.light} />
                <div className={styles.houseHeader} style={{paddingTop: routerSource == 'app' ? px2rem(80) : px2rem(20)}}>
                    <img src={`${BASE_IMG_URL}/house/back1.png`} alt="" className={styles.close} onClick={() => {
                        if (routerSource == 'app') {  // 如果是app打开，调用app给的js方法
                            // js_normal.onBackClick()
                        } else {  // 回到首页
                            window.ensureBack(
                                () => {
                                //   console.log('返回完成');
                                }
                            );
                            let { site } = this.props;
                            if (site) {
                                site.setShowHeader(true);
                            }
                        }
                    }} />
                </div>
                <div className={styles.ruleBox} onClick={() => {
                    this.setState({
                        rulePopupStatus: true
                    })
                }}>
                    <img src={`${BASE_IMG_URL}/house/icon1.png`} alt="" className={styles.ruleIcon} />
                    <span className={styles.ruleText}>规则</span>
                </div>
                <img src={`${BASE_IMG_URL}/house/img6.png`} alt="" className={styles.letterTitle}  style={{paddingTop: routerSource == 'app' ? px2rem(80) : 0}}/>
                <div className={styles.likeListBox}>
                    <div className={styles.countTitle}>已集赞</div>
                    {/* 点赞用户数 */}
                    <div className={styles.likeCountList}>
                        {likeCountList?.map((count: number, index: number) => (
                            <div key={index} className={styles.count}>
                                <div
                                    className={styles.countColumn}
                                    style={{
                                        transform: `translateY(-${px2rem(count * 68)})`
                                    }}
                                >
                                    {[0,1,2,3,4,5,6,7,8,9].map(d => (
                                        <div key={d} className={styles.countItem}>{d}</div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    {/* 点赞用户弹幕轨道（逐条循环无缝滚动） */}
                    <div className={styles.likeUserListBox}>
                        {(bulletConfigs || []).map((laneCfg: any, laneIndex: number) => (
                            <div className={styles.laneTrack} key={`lane-${laneIndex}`}>
                                <div className={styles.laneTrackInner} ref={this.getLaneRef(laneIndex)}>
                                    {laneCfg.laneUsers.map((user: any, idx: number) => (
                                        <div className={styles.likeUserItem} key={`${laneIndex}-${idx}`}>
                                            <img src={user.avatar} alt="" onError={this.handleImageError} className={styles.avatar} />
                                            <div className={styles.contentBox}>
                                                {user.type == 1 && <img src={`${BASE_IMG_URL}/house/icon2.png`} alt="" className={styles.likeIcon} />}
                                                <div className={styles.text}>{user.content}</div>
                                                {user.type == 2 && <img src={`${BASE_IMG_URL}/house/icon4.png`} alt="" className={styles.likeIcon} />}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {/* 点赞按钮、房产证按钮 */}
                <div className={styles.enterBtnBox}>
                    <div className={styles.likeBtnOuterBox}>
                        {/* <img src={`${BASE_IMG_URL}/house/icon2.png`} alt="" className={styles.likeBtnIcon} /> */}
                        <div className={`${styles.likeBtnBox} ${this.state.likeCountNumber > 0 ? styles.likeBtnBoxSmall : ''} ${this.state.likeBtnAnimating ? styles.likeBtnActive : ''}`} onClick={this.onLikeClick}>
                            <img src={`${BASE_IMG_URL}/house/icon7.png`} alt="" className={styles.btnIcon} />
                            <div className={styles.btnText}>{this.state.likeCountNumber > 0 ? `点赞+${this.state.likeCountNumber}` : '点赞'}</div>
                        </div>
                        {/* 飘动的点赞图标 */}
                        {floatingLikes.map(like => (
                            <img
                                key={like.id}
                                src={`${BASE_IMG_URL}/house/icon2.png`}
                                alt=""
                                className={styles.floatingLikeIcon}
                                style={{
                                    left: `calc(50% + ${like.left}px)`,
                                    '--x-offset': `${like.xOffset}px`
                                } as React.CSSProperties}
                            />
                        ))}
                    </div>
                    {/* 房产证入口 */}
                    {/* {(this.state.likeCountNumber > 0 || isIssued) && <div className={styles.likeBtnBox} */}
                    <div className={styles.likeBtnBox}
                        onClick={() => window.globalEnsureLogin(() => {
                            this.claimHouseCert();
                        })}
                    >
                        <img src={`${BASE_IMG_URL}/house/icon13.png`} alt="" className={styles.btnIcon} />
                        <div className={styles.btnText}>领房产证赢X300</div>    
                    </div>
                </div>

                {/* 规则弹框 */}
                {/* {rulePopupStatus && <div className={styles.popupBox}>
                    <div className={styles.popupMask} onClick={() => this.onHidePopup()}></div>
                    <div className={styles.popupContent}>
                        <div className={styles.popupTitle}>活动规则</div>
                        <div className={styles.ruleItem}>
                            <div>1.&nbsp;“为V粉搬新家点赞瓜分百万V币”第二轮<br />&nbsp;·&nbsp;活动时间：<span>即日起~2026年4月30日</span><br />&nbsp;·&nbsp;活动说明：活动时间内为V粉搬新家点赞，会有概率掉落V币奖励，获取的V币请下载登录vivo社区App，到<span>【V币商城页】</span>领取。</div>
                        </div>
                        <div className={styles.ruleItem}>
                            <div>2.&nbsp;“领房产证赢vivo X300手机”第二轮 <br />&nbsp;·&nbsp;活动时间：<span>即日起~2026年4月30日</span><br />&nbsp;·&nbsp;活动说明：2026年2月1日后注册vivo社区App并领取房产证，可获取抽奖资格，请下载登录vivo社区App，到<span>【首页】-【福利活动页】</span>查看活动详情及开奖信息。</div>
                        </div>
                        <div className={styles.popupBtn} onClick={() => this.onHidePopup()}>确定</div>
                    </div>
                </div>} */}

                {/* 中奖弹框 */}
                {/* {prizePopupStatus && <div className={styles.popupBox}>
                    <div className={styles.popupMask}></div>
                    <div className={styles.popupContent}>
                        <img src={`${BASE_IMG_URL}/house/icon10.png`} alt="" className={styles.popupIcon} />
                        <div className={styles.popupText}>恭喜抽中{this.state.prizeScore}V币</div>
                        <div className={styles.popupTip}>可到vivo社区APP端查看中奖记录</div>
                        <div className={styles.popupBtn} onClick={() => this.onHidePopup()}>确定</div>
                    </div>
                </div>} */}
                <CommonPopupNew
                    visible={prizePopupStatus}
                    title=""
                    isShowTitle={false}
                    isShowConfirm={false}
                    isShowCancel={false}
                    confirmText="确定"
                    onCancelChange={() => this.onHidePopup()}
                >
                    <div className={styles.rewardContent}>
                        {/* children 插槽内容 */}
                        <img src={`${BASE_IMG_URL}/house/icon10.png`} alt="" className={styles.popupIcon} />
                        <div className={styles.popupText}>恭喜抽中{this.state.prizeScore}V币</div>
                        <div className={styles.popupTip}>可到vivo社区APP端查看中奖记录</div>
                        <div className={styles.ruleConfirmBtn} style={{marginTop: px2rem(64)}} onClick={() => {
                            this.setState({
                                prizePopupStatus: false
                            })
                        }}>确定</div>
                    </div>
                </CommonPopupNew>


                {/* 规则弹框 */}
                <CommonRulePopup
                    visible={rulePopupStatus}
                    title="活动规则"
                    isShowConfirm={true}
                    useRichtext={false}
                    popupStyle={{position: "absolute", bottom: 0, left: px2rem(60)}}
                    confirmText='我知道了'
                    onConfirmButtonChange={() => this.onHidePopup()}
                >
                    <div className={styles.ruleItem}>
                        <div>1.&nbsp;“2026V粉嘉年华-为V粉搬新家点赞瓜分百万V币”<br />&nbsp;·&nbsp;活动时间：<span>即日起~2026年9月5日</span><br />&nbsp;·&nbsp;活动说明：活动时间内为V粉搬新家点赞，会有概率掉落V币奖励，获取的V币请下载登录vivo社区App，到<span>【V币商城页】</span>领取。</div>
                    </div>
                    <div className={styles.ruleItem}>
                        <div>2.&nbsp;“2026V粉嘉年华-领房产证赢vivo X300手机” <br />&nbsp;·&nbsp;活动时间：<span>即日起~2026年9月5日</span><br />&nbsp;·&nbsp;活动说明：即日起注册vivo社区App并领取房产证，可获取抽奖资格，请下载登录vivo社区App，到<span>【首页】-【福利活动页】</span>查看活动详情及开奖信息。</div>
                    </div>
                    {/* <div className={styles.ruleConfirmBtn} onClick={() => {
                        this.setState({
                            rulePopupStatus: false
                        })
                    }}>我知道了</div> */}
                </CommonRulePopup>

            </div>
        )
    }
}

export default withRouter(HouseLikeH5Page);
